import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail, ArrowUpRight } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/data/content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#FAF8F2] border-t border-neutral-200/70 mt-32 relative overflow-hidden"
    >
      <div aria-hidden className="absolute inset-x-0 top-0 h-px" style={{ background: "linear-gradient(90deg, transparent, rgba(212,175,55,0.7), rgba(199,127,0,0.7), transparent)" }} />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-12 py-14 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 sm:gap-12">
          <div className="md:col-span-5">
            <h3 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-neutral-900">
              Let&apos;s build something
              <br />
              <span className="italic text-aurora">unreasonably good.</span>
            </h3>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="btn-aurora mt-8 sm:mt-10 !py-3 !px-5"
            >
              Start a project <ArrowUpRight size={16} />
            </Link>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="overline mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-neutral-500 hover:text-gold transition"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Contact</p>
            <ul className="space-y-3 text-neutral-500">
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="hover:text-gold transition"
                  data-testid="footer-email"
                >
                  {BRAND.email}
                </a>
              </li>
              <li>{BRAND.phone}</li>
              <li>{BRAND.location}</li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a
                href={BRAND.social.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 inline-flex items-center justify-center border border-neutral-300 text-neutral-600 hover:border-gold hover:text-gold transition"
              >
                <Instagram size={16} />
              </a>
              <a
                href={BRAND.social.linkedin}
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="w-10 h-10 inline-flex items-center justify-center border border-neutral-300 text-neutral-600 hover:border-gold hover:text-gold transition"
              >
                <Linkedin size={16} />
              </a>
              <a
                href={BRAND.social.email}
                aria-label="Email GoldKey Studio"
                data-testid="footer-mail-link"
                className="w-10 h-10 inline-flex items-center justify-center border border-neutral-300 text-neutral-600 hover:border-gold hover:text-gold transition"
              >
                <Mail size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-200/70 mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-neutral-400 tracking-wider uppercase">
          <span>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</span>
          <span>
            Privacy · Terms ·{" "}
            <Link to="/admin" className="hover:text-gold transition" data-testid="footer-admin-link">
              Admin
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
